module.exports = __webpack_public_path__ + "static/helpgrowsmallbusiness-86354d562eae9992c62e96a83014e33f.svg";